import { createContext } from 'react';
import { IdbStorage } from '../util/idb-storage';

// @ts-ignore
export const IdbContext = createContext<IdbStorage>();